import { 
    CreatePackageTransportDto, 
    DeletePackageTransportDto,
    EditPackageTransportDto,
    GetPackageTransportDto, 
    MessageResponseDto, 
    PackageTransportApiFp,
    PackageTransportControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePackageTransportModel = PackageTransportControllerGet200Response;
export type GetPackageTransportModel = GetPackageTransportDto;
export type MutateResponsePackageTransportModel = MessageResponseDto;
export type CreatePackageTransportModel = CreatePackageTransportDto;
export type UpdatePackageTransportModel = EditPackageTransportDto;
export type DeletePackageTransportModel = DeletePackageTransportDto;

export const apiPackageTransportFp = PackageTransportApiFp(apiConfig);
export const getPackageTransportController = apiPackageTransportFp.packageTransportControllerGet;
export const createPackageTransportController = apiPackageTransportFp.packageTransportControllerCreate;
export const updatePackageTransportController = apiPackageTransportFp.packageTransportControllerEdit;
export const deletePackageTransportController = apiPackageTransportFp.packageTransportControllerDelete;

export const QueryKeyPackageTransport = QueryKey.PackageTransport;